import React from 'react';
import { Button, ButtonProps } from '../../../components/Button';
import { addQueryParamsToUrl, isAbsoluteUrl } from '../../../lib';
import {
    SanityObjectWithout,
    useLandingCTAQueryParam,
    useLpRedirect,
} from '../../../lib/landingPage';
import { Icon, IconProps } from '../Icon';
import { Wrapper } from '../Wrapper';

export type ButtonLinkProps = {
    newTab: boolean;
    href: string;
    text: string;
    size: ButtonProps['size'];
    buttonType: ButtonProps['type'];
    icon: SanityObjectWithout<IconProps, 'slug'>;
};

export const ButtonLink = Wrapper(
    ({ newTab, href, text, size, buttonType, icon }: ButtonLinkProps) => {
        const redirect = useLpRedirect();
        const pageParams = useLandingCTAQueryParam();
        const pageParamsHref = pageParams
            ? addQueryParamsToUrl(href, pageParams)
            : href;
        const props = (function () {
            if (newTab) {
                return {
                    rel: 'noopener noreferrer',
                    target: '_blank',
                    href: pageParamsHref,
                };
            } else if (isAbsoluteUrl(pageParamsHref)) {
                return { href: pageParamsHref };
            }
            return { onClick: () => redirect(pageParamsHref) };
        })();
        const iconNode = icon?.slug && <Icon value={icon} />;
        return (
            <Button size={size} icon={iconNode} type={buttonType} {...props}>
                {text}
            </Button>
        );
    },
    'buttonLink'
);
